export const handleBackToTopButton = function () {

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    window.onscroll = function() { scrollFunction() };

    function scrollFunction() {

        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            $('#kkr-back-to-top').addClass('show');

        } else {
            $('#kkr-back-to-top').removeClass('show');
        }
    }

    $('#kkr-back-to-top').on('click', function (e) {

        e.preventDefault();
        $('html,body').animate( { scrollTop: 0 }, 500 );
        
        // remove hash from url
        if( window.history.pushState ) {
            window.history.pushState( '', '/', window.location.pathname )
        } else {
            window.location.hash = '';
        }

    });

}
